import React from 'react'
import {CircularProgress, makeStyles} from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    wrapper: {
        position: "relative"
    },
    fabProgress: {
        position: 'absolute',
        left: -4,
        top: -4
    }
}))

function WorkableIcon(
    {
        working,
        Icon,
        ...props
    }) {
    const classes = useStyles();
    return (
        <span className={classes.wrapper}>
            <Icon {...props}/>
            {working && <CircularProgress size={32} className={classes.fabProgress}/>}
        </span>
    )
}

WorkableIcon.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    Icon: PropTypes.elementType,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIcon;